import React, { useEffect, useRef, useState } from "react";

let scriptPromise;
const loadRecaptcha = () => {
  if (window.grecaptcha?.render) return Promise.resolve(window.grecaptcha);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    const fail = () => {
      clearTimeout(timer);
      script.remove();
      delete window.plasticiseRecaptchaLoaded;
      scriptPromise = null;
      reject(new Error("Verification could not load."));
    };
    const timer = setTimeout(fail, 15000);
    window.plasticiseRecaptchaLoaded = () => {
      clearTimeout(timer);
      delete window.plasticiseRecaptchaLoaded;
      resolve(window.grecaptcha);
    };
    script.src = "https://www.google.com/recaptcha/api.js?onload=plasticiseRecaptchaLoaded&render=explicit";
    script.async = true;
    script.defer = true;
    script.onerror = fail;
    document.head.appendChild(script);
  });
  return scriptPromise;
};

export default function SignupCaptcha({ siteKey, onChange }) {
  const container = useRef(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    let widget;
    let api;
    const target = container.current;
    setError("");
    onChange("");
    loadRecaptcha().then((recaptcha) => {
      if (cancelled) return;
      api = recaptcha;
      widget = api.render(target, {
        sitekey: siteKey,
        size: "compact", // Fits narrow phones without clipping or scaling controls.
        callback: (token) => { if (!cancelled) { setError(""); onChange(token); } },
        "expired-callback": () => { if (!cancelled) { onChange(""); setError("Robot check expired. Please complete it again."); } },
        "error-callback": () => { if (!cancelled) { onChange(""); setError("Robot check unavailable. Please retry."); } },
      });
    }).catch(() => {
      if (!cancelled) { onChange(""); setError("Robot check unavailable. Check your connection and retry."); }
    });
    return () => {
      cancelled = true;
      if (widget !== undefined) api.reset(widget);
      target.replaceChildren();
    };
  }, [siteKey, onChange, attempt]);

  return (
    <div className="mb-3" aria-label="Robot verification">
      <div ref={container} />
      {error && <div role="alert">
        <p className="small mb-1">{error}</p>
        <button type="button" className="btn btn-link p-0" onClick={() => setAttempt((value) => value + 1)}>Retry robot check</button>
      </div>}
    </div>
  );
}
